import genererIntervenant from '@/services/devisCommandes/genererIntervenant';
import postGetCommandesList from '@/services/devisCommandes/postGetCommandesList';

export default function postGetPlanMedia(planMedia, users = []) {
  if (planMedia.datePM) planMedia.datePM = new Date(planMedia.datePM);
  if (planMedia.dateSignature) planMedia.dateSignature = new Date(planMedia.dateSignature);
  if (planMedia.dateDebut) planMedia.dateDebut = new Date(planMedia.dateDebut);
  if (planMedia.dateFin) planMedia.dateFin = new Date(planMedia.dateFin);
  planMedia.intervenants.push(genererIntervenant());
  planMedia.evenements.forEach(evenement => {
    evenement.selected = false;
    if (evenement.dateEvenement) evenement.dateEvenement = new Date(evenement.dateEvenement);
  });
  planMedia.commandes = [...planMedia.commandes, ...planMedia.devis];
  planMedia.commandes.forEach(c => {
    c.commercial = users.find(u => c.commercialId === u.id);
  });
  planMedia.commandes.forEach(postGetCommandesList);
  planMedia.commissions.forEach(commission => {
    commission.selected = false;
  });
  return planMedia;
}
